export default __webpack_public_path__ + "img/596c7e908aca60f02925a15431711e9b.png";